import React from 'react';
import { Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CommonTable from '../common/components/CommonTable';
import SiteCreatorTableRow from './SiteCreatorTableRow';
import CommonLoader from '../common/components/CommonLoader';
import { PrepareUrl } from '../common/helpers/PrepareUrl';
import RouterPaths from '../constants/RouterPaths';

const headers = [
  {
    label: 'ID',
  },
  {
    label: 'Name',
  },
  {
    label: 'Status',
  },
  {
    label: 'Action',
  },
];

function SiteCreatorTable({ data, offset, changeOffset }) {
  const navigate = useNavigate();
  const loaderStatus = useSelector((state) => state.siteCreator.get('loaderStatus'));

  const handleRowClick = (item) => {
    navigate(PrepareUrl(RouterPaths.EDIT_SITE, { id: item.id }));
  };

  return (
    <Col xs="12">
      <CommonLoader status={loaderStatus}>
        <CommonTable
          rowComponent={SiteCreatorTableRow}
          data={data}
          offset={offset}
          onOffsetChange={changeOffset}
          headers={headers}
          title="Site Creator"
          onRowClick={handleRowClick}
        />
      </CommonLoader>
    </Col>
  );
}

SiteCreatorTable.propTypes = {
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  changeOffset: PropTypes.func.isRequired,
};

export default SiteCreatorTable;
